<div [ngClass]="'idp__step' + (secondary ? '__secondary' : '')">
  <span [innerHtml]="label | slice : 0 : 2" class="idp__step-text"></span>
</div>
